import { render, staticRenderFns } from "./MassiveCertificationLoad.vue?vue&type=template&id=5373934b&scoped=true"
import script from "./MassiveCertificationLoad.vue?vue&type=script&lang=js"
export * from "./MassiveCertificationLoad.vue?vue&type=script&lang=js"
import style0 from "./MassiveCertificationLoad.vue?vue&type=style&index=0&id=5373934b&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5373934b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5373934b')) {
      api.createRecord('5373934b', component.options)
    } else {
      api.reload('5373934b', component.options)
    }
    module.hot.accept("./MassiveCertificationLoad.vue?vue&type=template&id=5373934b&scoped=true", function () {
      api.rerender('5373934b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/provider/massiveCertificationLoad/MassiveCertificationLoad.vue"
export default component.exports